import { useState } from "react";
import { X } from "lucide-react";

// Editable list of email domains (trusted / blocked) with optional suggestions
export const DomainList = ({ label, hint, value, suggestions = [], onSave, testid }) => {
  const [text, setText] = useState("");
  const add = (d) => {
    const v = d.trim().toLowerCase().replace(/^@/, "");
    if (v && !value.includes(v)) onSave([...value, v]);
    setText("");
  };
  return (
    <div className="mt-4" data-testid={testid}>
      <div className="text-sm font-medium text-neutral-800">{label}</div>
      <p className="text-xs text-neutral-500">{hint}</p>
      <div className="flex flex-wrap gap-1.5 mt-2">
        {value.map((d) => (
          <span key={d} className="domain-chip" data-testid={`${testid}-chip-${d}`}>
            {d}<button onClick={() => onSave(value.filter((x) => x !== d))} aria-label={`Remove ${d}`} data-testid={`${testid}-remove-${d}`}><X size={11} /></button>
          </span>
        ))}
        {!value.length && <span className="text-xs text-neutral-400">None</span>}
      </div>
      <form className="flex gap-2 mt-2" onSubmit={(e) => { e.preventDefault(); add(text); }}>
        <input className="login-input !mb-0 !py-1.5 !w-56" placeholder="example.com" value={text} onChange={(e) => setText(e.target.value)} data-testid={`${testid}-input`} />
        <button className="btn-outline !py-1.5 !px-3 text-xs" data-testid={`${testid}-add`}>Add</button>
      </form>
      {suggestions.length > 0 && (
        <div className="flex flex-wrap items-center gap-1.5 mt-2 text-xs text-neutral-500">
          Family domains:
          {suggestions.map((d) => <button key={d} className="domain-chip !bg-white" onClick={() => add(d)} data-testid={`${testid}-suggest-${d}`}>+ {d}</button>)}
        </div>
      )}
    </div>
  );
};
